import avatarTest from '../../images/others/avatar.png';
import { Typography, Avatar, Card, CardContent, Link, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import Scrollbars from "rc-scrollbars";
import UserAvatar from './UserAvatar';
import { useEffect, useRef, useState, useCallback } from 'react';
import { get } from 'api/apiBridges/httpBridge';
import { setState } from 'store/slices/dealTab';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import Loading from 'components/Load';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { RestrictedRangePicker } from "components/RangeDate";

// Вынесли функцию получения названия лога наружу, чтобы использовать её и в фильтре, и в самом логе
const getActionName = (act) => {
  switch (act) {
    case "create_deal": return "Создание сделки"
    case "change_deal_status": return "Изменение статуса сделки"
    case "move_to_box": return "Распределение товара по коробам"
    case "recover_qr": return "Восстановление qr"
    case "print_qr": return "Печать qr"
    case "move_box_to_deal": return "Перемещение коробов в сделку"
    case "move_box_from_deal": return "Перемещение коробов из сделки"
    case "move_product_to_deal": return "Перемещение товаров"
    case "change_deal_manager": return "Смена менеджера"
    case "print_barcode": return "Печать ШК"
    case "change_product_fields": return "Изменение полей продукта"
    case "change_deal_fields": return "Изменение полей сделки"
    case "add_pay_service": return "Добавление услуги на оплату"
    case "del_pay_service": return "Удаление услуги на оплату"
    case "set_pay": return "Изменение статуса оплаты"
    case "print_box_barcode": return "Печать ШК короба"
    case "print_market_barcode": return "Печать ШК маркетплейса для короба"
    case "print_shipment_barcode": return "Печать ШК поставки"
    case "print_box_barcode_all": return "Печать ШК всех коробов"
    case "print_market_barcode_all": return "Печать ШК маркетплейса для всех коробов"
    case "dnd_date": return "Дата отгрузки"
    case "change_consum_count": return "Изменение кол-ва расходников"
    case "close_deal": return "Завершение сделки"
    case "rename_boxes": return "Переименование коробов/паллет"
    case "add_product_to_deal": return "Добавление товаров"
    default: return act
  }
}

export default function Logs({ deal_id }) {
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const [filterType, setFilterType] = useState("all"); 
  const scrollbarsRef = useRef(null);

  const [dateRange, setDateRange] = useState({
    start: null,
    end: new Date()
  });

  const handleDateChange = useCallback(([s, e]) => {
    if (!s || !e) return;
    setDateRange({ start: s, end: e });
  }, []);

  // Загрузка логов
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const resp = await get("Logs/getOnDeal", { did: deal_id });
        if (resp) setLogs(resp);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [deal_id]);

  // Установка диапазона по минимальной и максимальной дате логов
  useEffect(() => {
    if (!logs || logs.length === 0) return;

    const minDate = logs.reduce((min, log) => {
      const logDate = new Date(log.createdAt);
      return logDate < min ? logDate : min;
    }, new Date(logs[0].createdAt));

    // const maxDate = logs.reduce((max, log) => {
    //   const logDate = new Date(log.createdAt);
    //   return logDate > max ? logDate : max;
    // }, new Date(logs[0].createdAt));

    const end = new Date(dateRange.end);
    end.setHours(23, 59, 59, 999);

    setDateRange({ start: minDate, end: end });
  }, [logs]);

  // Фильтрация логов
  const filteredLogs = Array.isArray(logs)
    ? logs.filter((log) => {
        const logDate = new Date(log.createdAt);
        const start = new Date(dateRange.start);
        start.setHours(0, 0, 0, 0);
        const end = new Date(dateRange.end);
        end.setHours(23, 59, 59, 999);

        const matchesType = filterType === "all" || log.type === filterType;
        const matchesDate = logDate >= start && logDate <= end;

        return matchesType && matchesDate;
      })
    : [];

  const uniqueLogTypes = [...new Set(logs.map((log) => log.type))];

  useEffect(() => {
    if (scrollbarsRef.current) {
      scrollbarsRef.current.scrollToBottom();
    }
  }, [filteredLogs]);

  if (loading || !dateRange.start) return <Loading />;

  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "5%",
          margin: "1%"
        }}
      >

        <RestrictedRangePicker
          start={dateRange.start}
          end={dateRange.end}
          onChange={handleDateChange}
          formate={undefined}
        />

        <FormControl size="small" style={{ minWidth: 250 }}>
          <InputLabel id="log-filter-label">Фильтр по типу</InputLabel>
          <Select
            labelId="log-filter-label"
            value={filterType}
            label="Фильтр по типу"
            onChange={(e) => setFilterType(e.target.value)}
          >
            <MenuItem value="all">
              <em>Все действия</em>
            </MenuItem>
            {uniqueLogTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {getActionName(type)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <Scrollbars
        ref={scrollbarsRef}
        autoHide
        style={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          height: "85%"
        }}
      >
        {filteredLogs.map((log, index) => (
          <Log key={index} log={log} />
        ))}
      </Scrollbars>
    </div>
  );
}

function Log({log}) {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getDealLink = (deal) => {
    // dispatch(setState({DealTab:deal}));
    // navigate('/DealTable')
    navigate(`/deal/${deal}`);
  }
  
  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr; 
    return date.toLocaleDateString('ru-RU');
  };

  const getContent = (act, data) => {
    switch (act) {
      case "create_deal":
        return (
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <Typography style={{fontSize: '12px' }}>
              SKU: {data.sku}
            </Typography>
            <Typography style={{fontSize: '12px' }}>
              Количество: {data.units}
            </Typography>
            {data.products && data.products.map((el, index) => {
              return (
                <div key={index} style={{ marginBottom: '5px' }}>
                  <Typography style={{ fontSize: '12px', fontStyle: 'italic', fontWeight: 'bold' }}>
                    {index + 1}) {el.title}
                  </Typography>

                  <div style={{ paddingLeft: '15px', marginTop: '1px' }}>
                    <Typography style={{ fontSize: '12px' }}>
                      - Баркод: {el.barcode}
                    </Typography>
                    
                    {el?.vendorCode && (
                      <Typography style={{ fontSize: '12px' }}>
                       - Артикул: {el.vendorCode}
                      </Typography>
                    )}
                    
                    <Typography style={{ fontSize: '12px' }}>
                     - Количество: {el.count}
                    </Typography>
                    
                    <Typography style={{ fontSize: '12px' }}>
                     - Взято из: {
                      <Link
                        component="button"
                        sx={{
                          fontSize: '14px',
                          fontWeight: 'bold',
                          color: '#000',
                          textDecoration: 'none',
                          '&:hover': {
                            color: '#078376',
                            textDecoration: 'underline',
                          }
                        }}
                        onClick={() => {getDealLink(el.deal_id)}}
                      >
                        {el.cdn}
                      </Link>
                     } - {el.boxTitle}
                    </Typography>
                  </div>
                </div>
              );
            })}
          </div>
        )

      case "close_deal":
        return ( <Typography style={{fontSize: '12px' }}>
              Сделка завершена
            </Typography>)
            
      case "change_deal_status":
        
        const oldText = data.oldType ? `${data.oldType}, Тестовый пример ${data.oldStatus}` : 'Старый статус';
        const newText = data.newType ? `${data.newType}, ${data.newStatus}` : `${data.type}, ${data.status}`;

        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography style={{ fontSize: '12px' }}>
              Перемещено в статус:
            </Typography>
            
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
              <Typography style={{ fontSize: '12px' }}>
                {data.oldType ? oldText : ''} 
              </Typography>
              {data.oldType && (
                <ArrowForwardIcon style={{ fontSize: '12px', color: '#000000' }} />
              )}
              <Typography style={{ fontSize: '12px', fontWeight: '500' }}>
                {newText}
              </Typography>
            </div>
          </div>
        )
      case "change_deal_manager": {
        // Достаем имена и ID, либо ставим заглушку, если менеджера не было
        const oldMngName = (data.oldManager && data.oldManager.fio) 
          ? `${data.oldManager.fio} (ID: ${data.oldManager.id})` 
          : (typeof data.oldManager === 'string' ? data.oldManager : 'Не был назначен');
          
        const newMngName = (data.newManager && data.newManager.fio)
          ? `${data.newManager.fio} (ID: ${data.newManager.id})`
          : 'Неизвестно';

        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography style={{ fontSize: '12px' }}>
              Менеджер сделки изменен:
            </Typography>
            
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginTop: '4px' }}>
              <Typography style={{ fontSize: '12px', color: '#666' }}>
                {oldMngName}
              </Typography>
              
              <ArrowForwardIcon style={{ fontSize: '14px', margin: '0 8px' }} />
              
              <Typography style={{ fontSize: '12px', fontWeight: 'bold',}}>
                {newMngName}
              </Typography>
            </div>

          </div>
        )
      }
      case "move_to_box":
        return (
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <Typography style={{fontSize: '12px', fontWeight: 'bold'}}>
              Перемещено в {data.box} 
            </Typography>
            
            {data.products.map((el, idx) =>{
              return (
                <div key={idx}>
                  <Typography style={{fontSize: '12px', fontStyle: 'italic'}}>
                    {el.title}
                  </Typography>
                  {el.oldBox  && data.box == 'Нераспределенный товар' && (
                    <Typography style={{ fontSize: '12px'}}>
                      Из короба: {el.oldBox}
                    </Typography>
                  )}
                  <Typography style={{fontSize: '12px' }}>
                    Баркод: {el.barcode}
                  </Typography>
                  {el?.vendorCode &&
                    <Typography style={{fontSize: '12px' }}>
                      Артикул: {el.vendorCode}
                    </Typography>}
                  <Typography style={{fontSize: '12px' }}>
                    Количество: {el.count}
                  </Typography>
                </div>
              )
            })}
          </div>
        )
      case "recover_qr":
        return (
          <div style={{display: 'flex', flexDirection: 'column'}}>
            {data.product?.title &&
              <Typography style={{fontSize: '12px', fontStyle: 'italic'}}>
                {data.product.title}
              </Typography>
            }
            {data.product?.barcode &&
              <Typography style={{fontSize: '12px' }}>
                Баркод: {data.product.barcode}
              </Typography>
            }
            {data.product?.vendorCode &&
            <Typography style={{fontSize: '12px' }}>
              Артикул: {data.product.vendorCode}
            </Typography>}
            {data.count &&
              <Typography style={{fontSize: '12px' }}>
                Восстановленно: {data.count}
              </Typography>
            }
            
          </div>
        )
      case "print_qr":
        return (
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <Typography style={{fontSize: '12px', fontStyle: 'italic'}}>
              {data.product.title}
            </Typography>
            <Typography style={{fontSize: '12px' }}>
              Баркод: {data.product.barcode}
            </Typography>
            {data.product?.vendorCode &&
            <Typography style={{fontSize: '12px' }}>
              Артикул: {data.product.vendorCode}
            </Typography>}
            <Typography style={{fontSize: '12px' }}>
              Распечатанно: {data.count}
            </Typography>
          </div>
        )
      case "move_box_to_deal":
        console.log('MPVE BOX DATA', data)
        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography style={{ fontSize: '14px' }}>
              Перемещено в сделку №{' '}
              <Link
                component="button"
                sx={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#000',
                  textDecoration: 'none',
                  '&:hover': {
                    color: '#078376',
                    textDecoration: 'underline',
                  }
                }}
                onClick={() => { getDealLink(data.newDeal) }}
              >
                {data.cdn}
              </Link>
            </Typography>

            <Typography style={{ fontSize: '12px', fontStyle: 'italic', fontWeight: 'bold' }}>
              Короба:
            </Typography>

            {data.boxes.map((box, idx) => (
              <div key={idx} style={{ paddingLeft: '5px', marginTop: '4px' }}>
                
                {/* Название короба из boxtitles */}
                <Typography style={{ fontSize: '12px', fontWeight: 'bold'}}>
                  - {data.boxtitles[idx]}
                </Typography>

                {/* Товары */}
                {box.products?.map((el, index) => (
                  <div key={index} style={{ marginBottom: '5px' }}>
                    <Typography style={{ fontSize: '12px', fontStyle: 'italic' }}>
                      {index + 1}) {el.title}
                    </Typography>

                    <div style={{ paddingLeft: '15px', marginTop: '1px' }}>
                      <Typography style={{ fontSize: '12px' }}>
                        - Баркод: {el.barcode}
                      </Typography>

                      <Typography style={{ fontSize: '12px' }}>
                        - Количество: {el.count}
                      </Typography>
                    </div>
                  </div>
                ))}

              </div>
            ))}
          </div>
        )

      case "move_box_from_deal":
        console.log('MPVE BOX DATA', data)
        let currData = data.list
        return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {currData.map((item, i) => (
            <div key={i} style={{ marginBottom: '12px' }}>
              <Typography style={{ fontSize: '14px' }}>
                Перемещено из сделки №{' '}
                <Link
                  component="button"
                  sx={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#000',
                    textDecoration: 'none',
                    '&:hover': {
                      color: '#078376',
                      textDecoration: 'underline',
                    }
                  }}
                  onClick={() => { getDealLink(item.newDeal) }}
                >
                  {item?.cdn}
                </Link>
              </Typography>

              <Typography style={{ fontSize: '12px', fontStyle: 'italic', fontWeight: 'bold' }}>
                Короба:
              </Typography>

              {item.boxes.map((box, idx) => (
                <div key={idx} style={{ paddingLeft: '5px', marginTop: '4px' }}>
                  
                  <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
                    - {item.boxtitles[idx]}
                  </Typography>

                  {box.products?.map((el, index) => (
                    <div key={index} style={{ marginBottom: '5px' }}>
                      <Typography style={{ fontSize: '12px', fontStyle: 'italic' }}>
                        {index + 1}) {el.title}
                      </Typography>

                      <div style={{ paddingLeft: '15px', marginTop: '1px' }}>
                        <Typography style={{ fontSize: '12px' }}>
                          - Баркод: {el.barcode}
                        </Typography>

                        <Typography style={{ fontSize: '12px' }}>
                          - Количество: {el.count}
                        </Typography>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      );
      case "move_product_to_deal":
        return (
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <Typography style={{fontSize: '14px'}}>
              Перемещено в сделку №{' '}
              <Link
                component="button"
                sx={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#000',
                  textDecoration: 'none',
                  '&:hover': {
                    color: '#078376',
                    textDecoration: 'underline',
                  }
                }}
                onClick={() => {getDealLink(data.newDeal)}}
              >
                {data.cdn}
              </Link>
            </Typography>
            {data.products.map((el, index) => {
              return (
                <div key={index} style={{ marginBottom: '5px' }}>
                  <Typography style={{ fontSize: '12px', fontStyle: 'italic', fontWeight: 'bold' }}>
                    {index + 1}) {el.title}
                  </Typography>

                  <div style={{ paddingLeft: '15px', marginTop: '1px' }}>
                    <Typography style={{ fontSize: '12px' }}>
                      - Баркод: {el.barcode}
                    </Typography>
                    
                    {el?.vendorCode && (
                      <Typography style={{ fontSize: '12px' }}>
                       - Артикул: {el.vendorCode}
                      </Typography>
                    )}
                    
                    <Typography style={{ fontSize: '12px' }}>
                     - Количество: {el.count}
                    </Typography>
                    
                    <Typography style={{ fontSize: '12px' }}>
                     - Взято из: {el.boxTitle}
                    </Typography>
                  </div>
                </div>
              );
            })}
            </div>
        )
      case "print_barcode":
        return (
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <Typography style={{fontSize: '12px', fontStyle: 'italic'}}>
              {data.title}
            </Typography>
            <Typography style={{fontSize: '12px' }}>
              Баркод: {data.barcode}
            </Typography>
            {data?.vendorCode &&
            <Typography style={{fontSize: '12px' }}>
              Артикул: {data.vendorCode}
            </Typography>}
            <Typography style={{fontSize: '12px' }}>
              Тип ШК: {data.type}
            </Typography>
            <Typography style={{fontSize: '12px' }}>
              Распечатанно: {data.count}
            </Typography>
          </div>
        )
      case "change_product_fields":
        const formatDate2 = (val) => {
          if (!val || val === 0) return '—';
          const date = new Date(val);
          if (!isNaN(date.getTime()) && typeof val === 'string' && val.includes('-')) {
            return date.toLocaleDateString('ru-RU');
          }
          return val;
        };

        const fieldLabels = {
          countProduct: 'Фактическое количество',
          countDefect: 'Количество брака',
          package: 'Упаковка',
          tags: 'Этикетки',
          labelsCount: 'Количество бирок',
          craftCount: 'Количество крафт-бумаги',
          bookletCount: 'Количество флаеров',
          zapayka: 'Запайка',
          inbox: 'Количество входящее в короб',
          expiration_date: 'Дата окончания срока годности',
          expiration_time: 'Срок годности',
          consumes: 'Расходники',
          services: 'Услуги',
          addedPrice: 'Добавленная стоимость'
        };

        const listFields = ['services', 'package', 'consumes'];

        const changes = data.changedFields
          .filter(ch => fieldLabels[ch.field])
          .map(ch => {
            if (listFields.includes(ch.field)) {
              const oldArr = Array.isArray(ch.oldValue) ? ch.oldValue : [];
              const newArr = Array.isArray(ch.newValue) ? ch.newValue : [];
              const changedItems = newArr.map(newItem => {
              const oldItem = oldArr.find(o => (o.id && o.id === newItem.id) || o.name === newItem.name);
              const isChanged = !oldItem || oldItem.count !== newItem.count || oldItem.val !== newItem.val;

                if (isChanged) {
                  return {
                    // Берем имя, если нет — берем val (для упаковок), если нет — заглушку
                    name: newItem.name || newItem.val || 'Элемент',
                    oldCount: oldItem ? (oldItem.count ?? oldItem.val) : null,
                    newCount: newItem.count ?? newItem.val
                  };
                }
                return null;
              }).filter(Boolean);

              if (changedItems.length === 0) return null;

              return {
                title: fieldLabels[ch.field],
                isList: true,
                listData: changedItems
              };
            }

            const isDate = ch.field === 'expiration_date';
            return {
              title: fieldLabels[ch.field],
              isList: false,
              oldValue: isDate ? formatDate2(ch.oldValue) : (ch.oldValue ?? 0),
              newValue: isDate ? formatDate2(ch.newValue) : ch.newValue
            };
          })
          .filter(Boolean);

        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography style={{ fontSize: '12px', fontStyle: 'italic' }}>
              {data.title}
            </Typography>
            
            <Typography style={{ fontSize: '12px' }}>
              Баркод: {data.barcode}
            </Typography>
            {data?.vendorCode &&
              <Typography style={{ fontSize: '12px' }}>
                Артикул: {data.vendorCode}
              </Typography>} 
            
            <Typography style={{ fontSize: '12px', fontWeight: 'bold', marginTop: '4px' }}>
              Измененные поля:
            </Typography>

            {changes.map((item, index) => {
              if (item.isList) {
                return (
                  <div key={index} style={{ display: 'flex', flexDirection: 'column', marginTop: '4px' }}>
                    <Typography style={{ fontSize: '12px', fontWeight: '500' }}>{item.title}:</Typography>
                    
                    {item.listData.map((subItem, idx) => (
                      <div key={idx} style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}>
                        <Typography style={{ fontSize: '12px' }}>- {subItem.name}:</Typography>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '4px' }}>
                          {subItem.oldCount !== null ? (
                            <>
                              <Typography style={{ fontSize: '12px' }}>{subItem.oldCount}</Typography>
                              <ArrowForwardIcon style={{ fontSize: '14px', margin: '0 2px' }} />
                              <Typography style={{ fontSize: '12px'}}>{subItem.newCount}</Typography>
                            </>
                          ) : (
                            <Typography style={{ fontSize: '12px' }}>{subItem.newCount}</Typography>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                );
              }

              return (
                <div key={index} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2px' }}>
                  <Typography style={{ fontSize: '12px' }}>
                    {item.title}:
                  </Typography>
                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: '4px' }}>
                    <Typography style={{ fontSize: '12px' }}>
                      {item.oldValue}
                    </Typography>
                    <ArrowForwardIcon style={{ fontSize: '14px', margin: '0 2px' }} />
                    <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
                      {item.newValue}
                    </Typography>
                  </div>
                </div>
              );
            })}
          </div>
        );
      
      case "change_deal_fields":
        let changesDeal = []
        const targetKey = 'data.pickup.volume';

        let shouldFlatten = false
        if (data.changedFields[1]?.field == targetKey || data.changedFields[2]?.field == targetKey){shouldFlatten = true} 

        let res = data.changedFields

        if (shouldFlatten){
          res = data.changedFields.flatMap(input => {
            const parentField = input.field;
            return Object.entries(input.newValue)
              .filter(([_, value]) => {
                const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
                const shortDateRegex = /^\d{4}-\d{1,2}-\d{1,2}$/;
                const isBasicValid = value !== null && value !== undefined && value !== 0 && value !== '';
                const isNotEmptyArray = !(Array.isArray(value) && value.length === 0);
                const isNotBadDate = typeof value === 'string' 
                  ? (shortDateRegex.test(value) ? isoRegex.test(value) : true) 
                  : true;

                return isBasicValid && isNotEmptyArray && isNotBadDate;
              })
              .map(([key, value]) => ({
                field: `${parentField}.${key}`,
                oldValue: undefined, 
                newValue: value
              }));
        });}

        for (let ch of res) {
          let title = undefined
          let hideValue = false
          let newValue = ch.newValue
          let oldValue = ch.oldValue

          switch (ch.field) {
              case 'warehouse_market': 
                title = 'Склад маркета'
              break
              case 'warehouse_tranzit':
                  title = 'Склад ФФ'
                  break
              case 'data.pickup.addr':
                  title = 'Адрес забора'
                  break
              case 'data.user.phone':
                  title = 'Телефон'
                  break
              case 'data.user.budjet':
                  title = 'Бюджет'
                  break
              case 'data.user.clientSource':
                  title = 'Канал привлечения'
                  break
              case 'data.pickup.sign':
                  title = 'Подпись забора'
                  break
              case 'data.pickup.phone':
                  title = 'Контакты (забор)'
                  break
              case 'data.acceptance.loader':
                  title = 'Грузчик приемки'
                  break
              // case 'data.acceptance.location':
              //     title = 'Локация приемки'
              //     break
              case 'data.adrst':
                  title = 'Адрес хранения'
                  break              
                  case 'data.acceptance.storageDate': 
                  title = 'Дата хранения'
                  newValue = formatDate(ch.newValue)
                  oldValue = (oldValue? formatDate(ch.oldValue) : undefined)
                  break
              case 'data.acceptance.placeType': 
                title = 'Тип места (приемка)'
              break
              case 'data.acceptance.placeCount': 
                title = 'Количество мест приемки'
              break
              case 'data.sort.sorter': 
                title = 'Сортировщик'
              break
              case 'data.sort.startDate': 
                  title = 'Дата начала сортировки'
                  newValue = formatDate(ch.newValue)
                  oldValue = (oldValue? formatDate(ch.oldValue) : undefined)
                  break
              case 'data.sort.finishDate': 
                  title = 'Дата окончания сортировки'
                  newValue = formatDate(ch.newValue)
                  oldValue = (oldValue? formatDate(ch.oldValue) : undefined)
                  break
              case 'data.sort.countIn':
                  title = 'Количество входящих (сортировка)'
                  break
              case 'data.sort.countOut':
                  title = 'Количество исходящих (сортировка)'
                  break
              case 'data.packaging.packager':
                  title = 'Упаковщик'
                  break
              case 'data.packaging.startDate': 
                  title = 'Дата начала упаковки'
                  newValue = formatDate(ch.newValue)
                  oldValue = (oldValue? formatDate(ch.oldValue) : undefined)
                  break
              case 'data.packaging.finishDate': 
                  title = 'Дата окончания упаковки'
                  newValue = formatDate(ch.newValue)
                  oldValue = (oldValue? formatDate(ch.oldValue) : undefined)
                  break
              case 'data.packaging.location':
                  title = 'Локация упаковки'
                  break
              case 'data.logistic.location':
                  title = 'Локация логистики'
                  break
              case 'data.logistic.type':
                  title = 'Тип логистики'
                  break
              case 'data.logistic.placeCount':
                  title = 'Количество мест (логистика)'
                  break
              case 'data.logistic.itemCount':
                  title = 'Количество товаров (логистика)'
                  break              
                case 'data.logistic.shipmentDate': 
                  title = 'Дата поступления'
                  newValue = formatDate(ch.newValue)
                  oldValue = (oldValue? formatDate(ch.oldValue) : undefined)
                  break
              case 'data.logistic.shipmentPlace': 
                title = 'Место отгрузки'
              break
              case 'data.logistic.pickupCost': 
                title = 'Себестоимость забора' 
              break
              case 'data.logistic.pickupDate': 
                  title = 'Дата поступления'
                  newValue = formatDate(ch.newValue)
                  oldValue = (oldValue? formatDate(ch.oldValue) : undefined)
                  break
              case 'data.logistic.paletCount':
                  title = 'Количество паллет'
                  break
              case 'data.acceptance.images':
                  title = 'Изображение приемка'
                  hideValue = true
                  break
              case 'data.packaging.images':
                  title = 'Изображение упаковка'
                  hideValue = true
                  break
              case 'data.shipmentCode':
                  title = 'ШК поставки'
                  break
              case 'data.shipmentNumber':
                  title = 'Номер поставки'
                  break
              case 'data.pricing.pickup':
                  title = 'Сумма за прием товара'
                  break
              case 'data.pricing.shipment':
                  title = 'Сумма за отгрузку товара'
                  break
              case 'data.pricing.storage':
                  title = 'Цена хранения за ед товара в сутки'
                  break
              case 'id':
                  title = 'Добавление услуги'
                  break
              // default:
              //     title = ch.field        
          }
          if (title) {changesDeal.push({title, newValue: newValue, oldValue: oldValue, hideValue: hideValue})}
        }
        return (
        <div style={{ display: 'flex', flexDirection: 'column'}}>
          <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
            Измененные поля:
          </Typography>
          {changesDeal.map((el, index) => {
            return (
              <div key={index} style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                {el.hideValue ? (
                  <Typography style={{ fontSize: '12px' }}>{el.title}</Typography>
                ) : (
                  <>
                    <Typography style={{ fontSize: '12px' }}>
                      {el.title}:
                    </Typography>
                    {el.oldValue !== undefined && el.oldValue !== null && el.oldValue !== "" && (
                      <>
                        <Typography style={{ fontSize: '12px'}}>
                          {el.oldValue}
                        </Typography>
                        <ArrowForwardIcon style={{ fontSize: '14px'}} />
                      </>
                    )}

                    <Typography style={{ fontSize: '12px', fontWeight: '500' }}>
                      {el.newValue}
                    </Typography>
                  </>
                )}
              </div>
            );
          })}
        </div>
        );
      case "add_pay_service":
        return (
          <Typography style={{fontSize: '12px', fontWeight: 'bold'}}>
            {data.service}
          </Typography>
        )
      case "del_pay_service":
        return(
          <Typography style={{fontSize: '12px', fontWeight: 'bold'}}>
            {data.service}
          </Typography>
        )
      case "set_pay":
        return (
          <Typography style={{fontSize: '12px', fontWeight: 'bold'}}>
            {data.statusPay? "Оплачено": "Не оплачено"}
          </Typography>
        )
      case "dnd_date":
        return(
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography style={{ fontSize: '12px' }}>
              {formatDate(data.oldValue)}
            </Typography>
            <ArrowForwardIcon style={{ fontSize: '14px' }} />
            <Typography style={{ fontSize: '12px', fontWeight: '500' }}>
              {formatDate(data.newValue)}
            </Typography>
        </div>
        )
      
      case "change_consum_count":
        console.log('WORKS', data)
        const consumTitle = data.fromDeal?.title || "Расходник";
        return (
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: '2px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography style={{ fontSize: '12px' }}>
                {consumTitle}:
              </Typography>
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: '4px' }}>
                <Typography style={{ fontSize: '12px' }}>
                  {data.old ?? 0}
                </Typography>
                <ArrowForwardIcon style={{ fontSize: '14px', margin: '0 4px' }} />
                <Typography style={{ fontSize: '12px'}}>
                  {data.new}
                </Typography>
              </div>
            </div>
          </div>
        );

      case "rename_boxes":
        return (
          <div>
            {data.list.map((el) => 
              <div style={{display: 'flex', flexDirection: 'row', alignItems: "center"}}>
                <Typography style={{ fontSize: '12px' }}>
                  {el.oldTitle}
                </Typography>
                <ArrowForwardIcon style={{ fontSize: '14px', margin: '0 4px' }} />
                <Typography style={{ fontSize: '12px'}}>
                  {el.title}
                </Typography>
              </div>
            )}
          </div>
        )
      
      case "add_product_to_deal":
        return (
          <div style={{display: 'flex', flexDirection: 'column'}}>
            {data.list && data.list.map((el, index) => {
              return (
                <div key={index} style={{ marginBottom: '5px' }}>
                  <Typography style={{ fontSize: '12px', fontStyle: 'italic', fontWeight: 'bold' }}>
                    {index + 1}) {el.title}
                  </Typography>

                  <div style={{ paddingLeft: '15px', marginTop: '1px' }}>
                    <Typography style={{ fontSize: '12px' }}>
                      - Баркод: {el.barcode}
                    </Typography>
                    
                    <Typography style={{ fontSize: '12px' }}>
                     - Количество: {el.count}
                    </Typography>
                    
                  </div>
                </div>
              );
            })}
          </div>
        )
          
      default:
        return act
    }

  }

  return (
    <Card sx={{ borderRadius: 3, boxShadow: 5, margin: "10px", width: "90%"}}>
      <CardContent>
        <div style={{display: 'flex', flexDirection: "column", alignItems: "flex-start", marginBottom: "5px", marginLeft: '10px'}}>
          <Typography style={{fontSize: '15px' }}>
            {getActionName(log.type)}
          </Typography>
          <Typography style={{fontSize: '12px' }}>
            Дата выполнения: {new Date(log.createdAt).toLocaleString('ru-RU', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
            })}
          </Typography>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: "center"}}>
            <UserAvatar src={log.user.avatar} userData={log.user} user_id={log.user_id} size={15} marginRight="5px"/>
            <Typography style={{fontSize: '12px' }}>
              {log.user.fio}
            </Typography>
          </div>  
        </div>  
        {Object.keys(log.data).length > 0 && 
          <div style={{marginLeft: "10px"}}>
            {getContent(log.type, log.data)}
          </div>  
        }    
      </CardContent>
  </Card>
  )
}

